/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */
import React, { memo } from 'react';

import Highlighter from 'react-highlight-words';

import { ISetFilterPayload } from '../../../../components/Table/helpers/filterAndSort';
import { KeyboardKeyCodeEnum } from '../../../app/appConstants';
import { ISuperSearchTranslation } from '../../../internationalization/types/corporate';
import { ISuperSearchMobileLabel } from '../../superSearchTypes';
import { declOfNum } from '../../superSearchUtils';
import {
    SuperSearchListGroupStyled,
    SuperSearchListGroupTitleStyled,
    SuperSearchListItem,
    SuperSearchListItemSecondary,
    SuperSearchListItemTitle,
} from '../styled/SuperSearchListStyled';

/**
 * @description Super search item mobile labels props
 * @interface ISuperSearchItemMobileLabelsProps
 * @property {ISuperSearchMobileLabel[]} mobileLabels - mobile labels list
 * @property {string} searchValue - search value
 * @property {(payload: ISetFilterPayload) => void} selectItem - select callback
 * @property {ICommonTranslation} translation - current locale
 */
export interface ISuperSearchItemMobileLabelsProps {
    mobileLabels: ISuperSearchMobileLabel[];
    searchValue: string;
    selectItem: (payload: ISetFilterPayload) => void;
    translation: ISuperSearchTranslation;
}

const SuperSearchItemMobileLabels = (props: ISuperSearchItemMobileLabelsProps) => {
    const selectHandler = (item: ISuperSearchMobileLabel) => {
        props.selectItem({
            field: 'labels',
            value: [{ value: item.id, label: item.name }],
        });
    };
    const keyDownHandler = (event: React.KeyboardEvent, item: ISuperSearchMobileLabel) => {
        if (event.keyCode === KeyboardKeyCodeEnum.ENTER) {
            selectHandler(item);
        }
    };
    return (
        <SuperSearchListGroupStyled>
            <SuperSearchListGroupTitleStyled>
                { props.translation.mobileLabels }
            </SuperSearchListGroupTitleStyled>
            {
                props.mobileLabels.map((item: ISuperSearchMobileLabel) => (
                    <SuperSearchListItem
                        key={ item.id }
                        onClick={ () => selectHandler(item) }
                        onKeyDown={ (e: React.KeyboardEvent) => keyDownHandler(e, item) }
                    >
                        <SuperSearchListItemTitle>
                            <Highlighter
                                autoEscape={ true }
                                highlightClassName="super-search__item-text_bold"
                                searchWords={ props.searchValue.split(' ') }
                                textToHighlight={ item.name }
                            />
                        </SuperSearchListItemTitle>
                        <SuperSearchListItemSecondary>
                            <Highlighter
                                autoEscape={ true }
                                highlightClassName="super-search__item-text_bold"
                                searchWords={ props.searchValue.split(' ') }
                                textToHighlight={
                                    item.subsCount + ' ' + declOfNum(item.subsCount, props.translation.mobilesCount)
                                }
                            />
                        </SuperSearchListItemSecondary>
                    </SuperSearchListItem>
                ))
            }
        </SuperSearchListGroupStyled>
    );
};

export default memo(SuperSearchItemMobileLabels);
